import React, { createContext, useContext } from 'react';

// Létrehozzuk a kontextusokat
export const AppContext = createContext(null);
export const ModalsContext = createContext(null);

// Hook-ok a kontextusok könnyű használatához
export const useAppContext = () => {
  const context = useContext(AppContext);
  if (context === undefined) {
    throw new Error('useAppContext must be used within an AppProvider');
  }
  return context;
};

export const useModalsContext = () => {
  const context = useContext(ModalsContext);
  if (context === undefined) {
    throw new Error('useModalsContext must be used within a ModalsProvider');
  }
  return context;
};

/**
 * Ez a Higher-Order Component lehetővé teszi, hogy az App osztály komponens
 * hozzáférjen az AppContext kontextushoz a props-on keresztül.
 * 
 * Mivel az App komponens az egyik legfelső szintű komponens, nem egyszerű
 * számára kontextust használni, mert ő maga is része a kontextusnak.
 */
export const withAppContext = (Component) => {
  return React.forwardRef((props, ref) => (
    <AppContext.Consumer>
      {appContext => <Component {...props} appContext={appContext} ref={ref} />}
    </AppContext.Consumer>
  ));
};

export const withModalsContext = (Component) => {
  return React.forwardRef((props, ref) => (
    <ModalsContext.Consumer>
      {modalsContext => <Component {...props} modalsContext={modalsContext} ref={ref} />}
    </ModalsContext.Consumer>
  ));
};